export default {
    title: "1Byte's Reminders",
    unrenewed_service: {
        title: 'Services have not been renewed',
    },
    unpaid_invoice: {
        title: 'Invoices have not been paid',
    },
};
